type Props = {
  src: string;
  alt?: string;
  className?: string;
  /** Header/detail backgrounds use smooth scaling; gallery cards stay pixelated. */
  smooth?: boolean;
};

/** Cover banner image (pixel-art or smooth). */
export function WavePixelArtCover({ src, alt = "", className = "", smooth = false }: Props) {
  return (
    <img
      src={src}
      alt={alt}
      className={`${smooth ? "wave-smooth-cover" : "wave-pixel-cover"} ${className}`.trim()}
      loading="lazy"
      decoding="async"
    />
  );
}
